export default function IconHeadingSmall({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      viewBox="0 0 29.8932 23.7779"
      fill="none"
      className={className}
    >
      <path
        d="M28.2032 22.0879H21.0676V19.9004C21.0676 18.742 21.722 17.6831 22.7581 17.1651L26.6855 15.2014C27.571 14.7586 28.2032 13.9034 28.2032 12.9134C28.2032 12.2362 28.1481 11.5719 28.0424 10.9246C27.8592 9.80401 26.908 8.99227 25.7761 8.9016C25.2318 8.85799 24.6813 8.83575 24.1257 8.83575C23.0863 8.83575 22.0652 8.91354 21.0676 9.06359M1.69 1.69V11.8848M1.69 11.8848V22.0795M1.69 11.8848L15.9616 11.8857M15.9616 11.8857V1.69099M15.9616 11.8857V22.0804"
        stroke="currentColor"
        vectorEffect="non-scaling-stroke"
        strokeWidth={1}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
